import React, { useEffect ,useState,memo} from 'react';
import HeaderTwo from './HeaderTwo'
import noImage from './asset/image/no-image-icon.png';
import Filter from './component/Filter'
import {Link} from "react-router-dom";
import {ResGet,url} from './component/resapi'
// import CSSTransitionGroup from 'react-transition-group/CSSTransitionGroup';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';
import ScrollMenu from 'react-horizontal-scrolling-menu';
import imagesLoead from './component/utility/imageLoad'
import Div100vh from 'react-div-100vh'
import {connect} from 'react-redux';
import {isLoading} from "./redux/actions"


const Homework =({isLoading})=>{
  const [count, setcount] = useState(0)
  const [filter, setfilter] = useState(false)
  const [isPause, setisPause] = useState(false)
  const [loading, setloading] = useState(true)
  const [data, setData] = useState([])
  
  function handleReg(skipLimit){
      ResGet(`getwork/all/${skipLimit}`).then(async(response)=>{
        if(response.status===200 && response.data.length>0){
          await setData(value=>[...value,...response.data])
          await handleReg(skipLimit+20)
        }
        else{
          setTimeout(() => {
            imagesLoead(()=>{
              setloading(false)
              isLoading(true)
            })
          }, 1100);
            
        }
      })
  }
  useEffect(() => {
    isLoading(false)
    ResGet("getwork/all/0").then(async(response)=>{
      if(response.status===200){
        await setData(response.data)
        await handleReg(20)
      }
    })
  },[])
  const autoSlide=()=>{
    if(!isPause){
        if(count===(data.length-1)){
          setcount(0)
        }
        else {
          setcount(value=>value+1)
        }
    }
    return;
  }
  useEffect(() => {
    let timer = null;
    clearInterval(timer)
    timer = setInterval(autoSlide, 5500)
    document.querySelector("#home-menu").addEventListener("mouseleave",()=>setisPause(false))
    document.querySelector("#home-menu").addEventListener("mouseenter",()=>setisPause(true))
    return () => {
      clearInterval(timer)
      document.querySelector("#home-menu").removeEventListener("mouseleave",()=>setisPause(false))
      document.querySelector("#home-menu").removeEventListener("mouseenter",()=>setisPause(true))
    };
  }, [count,isPause,data])

  const handelIsActiveFilter=()=>{
    setfilter(true)
  }

  const onSelect = key => {
    setcount(parseFloat(key))
  }
  const handelSelectCard =()=>{
    const items = data.map((value,key) =>
    key===parseFloat(count)?<Card key={key} data={value}/>:""
    );
    return items
  }
  return (
    <Div100vh style={{height:"100rvh",overflow:"hidden"}}>
   {!loading? 
      <HeaderTwo active={filter} close={()=>setfilter(false)}>
          <Filter  onSetData={setData} setcount={setcount}/>
      </HeaderTwo>
    :""}
    <div className="bg-fixed">
        <div className="slider">
        <div className="box light clickable">

          {!loading?
            <ReactCSSTransitionGroup
            transitionName="example"
            transitionEnterTimeout={400}
            transitionLeaveTimeout={600}
            >
              {handelSelectCard()}
            </ReactCSSTransitionGroup>
          :
          data.map((value,key) =>
            <Card key={key} data={value}/>
          )}
        </div>
        </div>
        <div className="home-menu" id="home-menu">
               <ScrollMenu
                data={Menu(data, count)}
                arrowLeft={ArrowLeft}
                arrowRight={ArrowRight}
                selected={count}
                onSelect={onSelect}
                transition="0.43"
                alignCenter={false}
                />
              <div className="filter clickable">
                <span onClick={()=>handelIsActiveFilter()}><i className="icon icon-filter"></i> <span>FILTER</span></span>
              </div>
        </div>       
    </div>
    </Div100vh>
  );
  // else return 
  }

const MenuItem = ({text, selected}) => {
  return (
  <div className={`menu-item  ${selected ? 'active' : ''}`}>
      {selected?
      <Link to={`/work/${text.split(" ").join("-")}`} className="hoverline clickable">{text}</Link>
      :
      <span className="hoverline clickable" style={{opacity:selected?"1":"0.4"}}>{text}</span>
      }
   </div>
  )
};
const Menu = (list, selected) =>list.map((el,key) => {
    const {name} = el;
    return <MenuItem text={name} key={key} selected={key} />;
});
const Arrow = ({className}) => {
  return (
    <div className="icons clickable"><span className="clickable" style={{lineHeight:0}}> <i className={className}></i></span></div>
  );
};
const ArrowLeft = Arrow({ className: 'icon icon-arrow-left' });
const ArrowRight = Arrow({ className: 'icon icon-arrow-right' });

const Card = memo(props=>{
  return(
    <Link to={{
      pathname: `/work/${props.data.name.split(" ").join("-")}`,
      state: { id: props.data.id }
      }}
    >
          <div className="text">
            <div className="image">
              <img src={props.data.preview?url+"/"+props.data.preview:noImage} alt={`slide-${props.data.name}`}/>
            </div>
          </div>
          <div className="title">
            <span>{props.data.date}</span>
            <span><img src={url+"/"+props.data.flag} alt="flag"/></span>
            <span>{props.data.country}</span>
          </div>
    </Link>
  )
})

export default connect(null,{isLoading})(Homework);
